import { GEO_FIELD_NAMES, REGION_TO_KLADR, DEFAULT_KLADR_CODE } from './actionTypes';

export const selectGeoState = (state) => state.geolocation;

export const selectLocation = (state) => state.geolocation.location;

export const selectRegion = (state) => state.geolocation.location[GEO_FIELD_NAMES.REGION];

export const selectRegionCode = (state) => state.geolocation.location[GEO_FIELD_NAMES.REGION_CODE];

export const selectCity = (state) => state.geolocation.location[GEO_FIELD_NAMES.CITY];

export const selectCountry = (state) => state.geolocation.location[GEO_FIELD_NAMES.COUNTRY];

export const selectCountryCode = (state) => state.geolocation.location[GEO_FIELD_NAMES.COUNTRY_CODE];

export const selectCoordinates = (state) => ({
    latitude: state.geolocation.location[GEO_FIELD_NAMES.LATITUDE],
    longitude: state.geolocation.location[GEO_FIELD_NAMES.LONGITUDE],
});

export const selectTimezone = (state) => state.geolocation.location[GEO_FIELD_NAMES.TIMEZONE];

export const selectIsGeoFetching = (state) => state.geolocation.isFetching;

export const selectIsGeoLoaded = (state) => state.geolocation.isLoaded;

export const selectGeoError = (state) => state.geolocation.error;

export const selectLocationString = (state) => {
    const location = state.geolocation.location;
    const region = location[GEO_FIELD_NAMES.REGION];
    const city = location[GEO_FIELD_NAMES.CITY];

    if (city && region && city !== region) {
        return `${city}, ${region}`;
    }
    return region || city || 'Определение региона...';
};

export const selectRegionShort = (state) => {
    const region = state.geolocation.location[GEO_FIELD_NAMES.REGION];
    return region || 'Выберите регион';
};

export const selectRegionKladr = (state) => {
    const countryCode = state.geolocation.location[GEO_FIELD_NAMES.COUNTRY_CODE];
    const regionCode = state.geolocation.location[GEO_FIELD_NAMES.REGION_CODE];

    if (countryCode !== 'RU') {
        return DEFAULT_KLADR_CODE;
    }

    return REGION_TO_KLADR[regionCode] || DEFAULT_KLADR_CODE;
};

export const geoSelectors = {
    selectGeoState,
    selectLocation,
    selectRegion,
    selectRegionCode,
    selectCity,
    selectCountry,
    selectCountryCode,
    selectCoordinates,
    selectTimezone,
    selectIsGeoFetching,
    selectIsGeoLoaded,
    selectGeoError,
    selectLocationString,
    selectRegionShort,
    selectRegionKladr,
};